import { render, staticRenderFns } from "./SaleDetailBrowse.vue?vue&type=template&id=2efcbaff"
import script from "./SaleDetailBrowse.vue?vue&type=script&lang=ts"
export * from "./SaleDetailBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efcbaff')) {
      api.createRecord('2efcbaff', component.options)
    } else {
      api.reload('2efcbaff', component.options)
    }
    module.hot.accept("./SaleDetailBrowse.vue?vue&type=template&id=2efcbaff", function () {
      api.rerender('2efcbaff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/SaleDetailBrowse.vue"
export default component.exports